import { AgentSearchCriteria, AgentSearchResponse } from '@/types/agents'
import axios, { AxiosInstance } from 'axios'
import { v4 as uuidv4 } from 'uuid'
import rollbar from './rollbar'
import omit from 'lodash/omit'
import { initialqueryResponse } from '@/store/models/search'
import {
  LocationsNearbyQuery,
  LocationsNearbyResponse
} from '@/types/locations'

const axiosConfig = {
  baseURL:
    process.env.NEXT_PUBLIC_APP_ENV === 'prod'
      ? 'https://agent-seeker.bankrate.com/'
      : 'https://agent-seeker.qa.bankrate.com/'
}

const baseLocationsNearbyDimensions: LocationsNearbyQuery = {
  limit: 4,
  radius: 200,
  sort_by: 'distance_in_miles'
}

export class AgentApi {
  constructor(public client: AxiosInstance = axios.create(axiosConfig)) {}

  async fetchAgents(
    payload: AgentSearchCriteria
  ): Promise<AgentSearchResponse> {
    try {
      const query = omit(payload, ['sort_by', 'limit'])
      const { data } = await this.client.post('/search', {
        query: { ...query, property_type: query.property_type.split(',') },
        sort_by: payload.sort_by,
        limit: payload.limit
      })

      return data
    } catch (err) {
      if (
        typeof window === 'undefined' &&
        process.env.NEXT_PUBLIC_APP_ENV !== 'local'
      ) {
        // This is means is a server side error and if so
        // we should throw it so the error boundary can catch it
        throw err
      }

      rollbar.error('failed to fetch agents from api', err)
      const agentSearchFallback: AgentSearchResponse = {
        ...initialqueryResponse,
        sorty_by: payload.sort_by,
        request_id: uuidv4()
      }

      return agentSearchFallback
    }
  }

  async fetchNearbyLocations(
    zipcode: string,
    locationNearbyQuery: LocationsNearbyQuery = baseLocationsNearbyDimensions
  ): Promise<LocationsNearbyResponse> {
    try {
      const { data } = await this.client.get<LocationsNearbyResponse>(
        `locations/${zipcode}/nearby`,
        {
          params: omit(locationNearbyQuery, ['zipcode'])
        }
      )

      return data
    } catch (err) {
      if (
        typeof window === 'undefined' &&
        process.env.NEXT_PUBLIC_APP_ENV !== 'local'
      ) {
        // This is means is a server side error and if so
        // we should throw it so the error boundary can catch it
        throw err
      }

      rollbar.error('failed to fetch nearby locations from api', err)
      return null
    }
  }
}

export const agentApi = new AgentApi()
